const mapping: Record<string, string> = {
  id: 'e=>e.Id',
}

export const mapSortEngineMediaFileParam = (key: string) => mapping[key]
